/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { settlingin_AffectedPlanResponse } from '../models/settlingin_AffectedPlanResponse';
import type { settlingin_ApplyBillingRequest } from '../models/settlingin_ApplyBillingRequest';
import type { settlingin_ApplyBillingResponse } from '../models/settlingin_ApplyBillingResponse';
import type { settlingin_BillingPreviewResponse } from '../models/settlingin_BillingPreviewResponse';
import type { settlingin_BulkCreateScheduleEntriesRequest } from '../models/settlingin_BulkCreateScheduleEntriesRequest';
import type { settlingin_BulkCreateTrackingEntriesRequest } from '../models/settlingin_BulkCreateTrackingEntriesRequest';
import type { settlingin_CompleteRequest } from '../models/settlingin_CompleteRequest';
import type { settlingin_CompletionWarningsResponse } from '../models/settlingin_CompletionWarningsResponse';
import type { settlingin_CreatePlanRequest } from '../models/settlingin_CreatePlanRequest';
import type { settlingin_CreateProgressEntryRequest } from '../models/settlingin_CreateProgressEntryRequest';
import type { settlingin_CreateTrackingEntryRequest } from '../models/settlingin_CreateTrackingEntryRequest';
import type { settlingin_PlanDetailResponse } from '../models/settlingin_PlanDetailResponse';
import type { settlingin_PlanListResponse } from '../models/settlingin_PlanListResponse';
import type { settlingin_PlanResponse } from '../models/settlingin_PlanResponse';
import type { settlingin_ProgressEntryResponse } from '../models/settlingin_ProgressEntryResponse';
import type { settlingin_ScheduleEntryResponse } from '../models/settlingin_ScheduleEntryResponse';
import type { settlingin_SignOffRequest } from '../models/settlingin_SignOffRequest';
import type { settlingin_TrackingEntryResponse } from '../models/settlingin_TrackingEntryResponse';
import type { settlingin_UpdatePlanRequest } from '../models/settlingin_UpdatePlanRequest';
import type { settlingin_UpdateProgressEntryRequest } from '../models/settlingin_UpdateProgressEntryRequest';
import type { settlingin_UpdateScheduleEntryRequest } from '../models/settlingin_UpdateScheduleEntryRequest';
import type { settlingin_UpdateTrackingEntryRequest } from '../models/settlingin_UpdateTrackingEntryRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SettlingInService {
    /**
     * List settling-in plans
     * @param page Page number
     * @param pageSize Page size
     * @param groupId Filter by group ID
     * @param childcareId Filter by childcare ID
     * @param completed Filter by completion status
     * @param withContracts Filter by children with current or upcoming contracts
     * @param status Filter by derived status
     * @param sort Sort order
     * @param childId Filter by child ID
     * @returns settlingin_PlanListResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingIn(
        page: number = 1,
        pageSize: number = 20,
        groupId?: string,
        childcareId?: string,
        completed?: boolean,
        withContracts?: boolean,
        status?: 'planned' | 'running' | 'needs_attention' | 'completed' | 'signed_off' | 'billed',
        sort?: 'needs_action' | 'start_date',
        childId?: string,
    ): CancelablePromise<settlingin_PlanListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in',
            query: {
                'page': page,
                'pageSize': pageSize,
                'group_id': groupId,
                'childcare_id': childcareId,
                'completed': completed,
                'with_contracts': withContracts,
                'status': status,
                'sort': sort,
                'child_id': childId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a settling-in plan
     * @param request Plan data
     * @returns settlingin_PlanResponse Created
     * @throws ApiError
     */
    public static postApiV1SettlingIn(
        request: settlingin_CreatePlanRequest,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in',
            body: request,
            errors: {
                400: `Bad Request`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Soft-delete a settling-in plan
     * @param id Plan ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1SettlingIn(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/settling-in/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Get a settling-in plan with details
     * @param id Plan ID
     * @returns settlingin_PlanDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingIn1(
        id: string,
    ): CancelablePromise<settlingin_PlanDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Update a settling-in plan
     * @param id Plan ID
     * @param request Plan data
     * @returns settlingin_PlanResponse OK
     * @throws ApiError
     */
    public static putApiV1SettlingIn(
        id: string,
        request: settlingin_UpdatePlanRequest,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/settling-in/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Preview the settling-in billing charge for a plan
     * @param id Plan ID
     * @param asOf Prospective sign-off date (YYYY-MM-DD) used to resolve the target invoice period
     * @returns settlingin_BillingPreviewResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingInBillingPreview(
        id: string,
        asOf?: string,
    ): CancelablePromise<settlingin_BillingPreviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/billing-preview',
            path: {
                'id': id,
            },
            query: {
                'as_of': asOf,
            },
            errors: {
                400: `Invalid plan ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Settling-in plan not found`,
                500: `Failed to compute billing preview`,
            },
        });
    }
    /**
     * Undo completion of a settling-in plan
     * @param id Plan ID
     * @returns settlingin_PlanResponse OK
     * @throws ApiError
     */
    public static deleteApiV1SettlingInComplete(
        id: string,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/settling-in/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Mark a settling-in plan as completed
     * @param id Plan ID
     * @param request Completion data
     * @returns settlingin_PlanResponse OK
     * @throws ApiError
     */
    public static postApiV1SettlingInComplete(
        id: string,
        request: settlingin_CompleteRequest,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/{id}/complete',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                404: `Not Found`,
                409: `Conflict`,
                422: `Plan already completed`,
            },
        });
    }
    /**
     * Update the end date of a completed settling-in plan
     * @param id Plan ID
     * @param request Completion data
     * @returns settlingin_PlanResponse OK
     * @throws ApiError
     */
    public static putApiV1SettlingInComplete(
        id: string,
        request: settlingin_CompleteRequest,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/settling-in/{id}/complete',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Preview warnings before completing a settling-in plan
     * @param id Plan ID
     * @returns settlingin_CompletionWarningsResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingInCompletionWarnings(
        id: string,
    ): CancelablePromise<settlingin_CompletionWarningsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/completion-warnings',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid plan ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Settling-in plan not found`,
                500: `Failed to load completion warnings`,
            },
        });
    }
    /**
     * List progress entries for a settling-in plan
     * @param id Plan ID
     * @returns settlingin_ProgressEntryResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingInProgress(
        id: string,
    ): CancelablePromise<Array<settlingin_ProgressEntryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/progress',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Create a progress entry for a settling-in plan
     * @param id Plan ID
     * @param request Progress entry data
     * @returns settlingin_ProgressEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1SettlingInProgress(
        id: string,
        request: settlingin_CreateProgressEntryRequest,
    ): CancelablePromise<settlingin_ProgressEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/{id}/progress',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Soft-delete a progress entry
     * @param id Plan ID
     * @param entryId Entry ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1SettlingInProgress(
        id: string,
        entryId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/settling-in/{id}/progress/{entryId}',
            path: {
                'id': id,
                'entryId': entryId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Update a progress entry
     * @param id Plan ID
     * @param entryId Entry ID
     * @param request Progress entry data
     * @returns settlingin_ProgressEntryResponse OK
     * @throws ApiError
     */
    public static putApiV1SettlingInProgress(
        id: string,
        entryId: string,
        request: settlingin_UpdateProgressEntryRequest,
    ): CancelablePromise<settlingin_ProgressEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/settling-in/{id}/progress/{entryId}',
            path: {
                'id': id,
                'entryId': entryId,
            },
            body: request,
            errors: {
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Download the settling-in progress summary PDF
     * Generate and download the behavioural progress summary for a settling-in plan
     * @param id Plan ID
     * @param lang Language
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1SettlingInProgressPdf(
        id: string,
        lang: 'de' | 'en' | 'fr' | 'it' | 'es' | 'pt' = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/progress/pdf',
            path: {
                'id': id,
            },
            query: {
                'lang': lang,
            },
            errors: {
                400: `Invalid plan ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Settling-in plan not found`,
                500: `Failed to generate PDF`,
            },
        });
    }
    /**
     * List schedule entries for a settling-in plan
     * @param id Plan ID
     * @returns settlingin_ScheduleEntryResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingInSchedule(
        id: string,
    ): CancelablePromise<Array<settlingin_ScheduleEntryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/schedule',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Create schedule entries for a settling-in plan
     * @param id Plan ID
     * @param request Schedule entries data
     * @returns settlingin_ScheduleEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1SettlingInSchedule(
        id: string,
        request: settlingin_BulkCreateScheduleEntriesRequest,
    ): CancelablePromise<Array<settlingin_ScheduleEntryResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/{id}/schedule',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Soft-delete a schedule entry
     * @param id Plan ID
     * @param entryId Entry ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1SettlingInSchedule(
        id: string,
        entryId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/settling-in/{id}/schedule/{entryId}',
            path: {
                'id': id,
                'entryId': entryId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Update a schedule entry
     * @param id Plan ID
     * @param entryId Entry ID
     * @param request Schedule entry data
     * @returns settlingin_ScheduleEntryResponse OK
     * @throws ApiError
     */
    public static putApiV1SettlingInSchedule(
        id: string,
        entryId: string,
        request: settlingin_UpdateScheduleEntryRequest,
    ): CancelablePromise<settlingin_ScheduleEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/settling-in/{id}/schedule/{entryId}',
            path: {
                'id': id,
                'entryId': entryId,
            },
            body: request,
            errors: {
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Download the settling-in schedule PDF
     * Generate and download the Eingewoehnungsplan for a settling-in plan
     * @param id Plan ID
     * @param lang Language
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1SettlingInSchedulePdf(
        id: string,
        lang: 'de' | 'en' | 'fr' | 'it' | 'es' | 'pt' = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/schedule/pdf',
            path: {
                'id': id,
            },
            query: {
                'lang': lang,
            },
            errors: {
                400: `Invalid plan ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Settling-in plan not found`,
                500: `Failed to generate PDF`,
            },
        });
    }
    /**
     * Undo sign-off of a settling-in plan
     * @param id Plan ID
     * @returns settlingin_PlanResponse OK
     * @throws ApiError
     */
    public static deleteApiV1SettlingInSignOff(
        id: string,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/settling-in/{id}/sign-off',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Sign off a settling-in plan by parent/contact
     * @param id Plan ID
     * @param request Sign-off data
     * @returns settlingin_PlanResponse OK
     * @throws ApiError
     */
    public static postApiV1SettlingInSignOff(
        id: string,
        request: settlingin_SignOffRequest,
    ): CancelablePromise<settlingin_PlanResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/{id}/sign-off',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * List tracking entries for a settling-in plan
     * @param id Plan ID
     * @returns settlingin_TrackingEntryResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingInTracking(
        id: string,
    ): CancelablePromise<Array<settlingin_TrackingEntryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/{id}/tracking',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Create a tracking entry for a settling-in plan
     * @param id Plan ID
     * @param request Tracking entry data
     * @returns settlingin_TrackingEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1SettlingInTracking(
        id: string,
        request: settlingin_CreateTrackingEntryRequest,
    ): CancelablePromise<settlingin_TrackingEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/{id}/tracking',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Soft-delete a tracking entry
     * @param id Plan ID
     * @param entryId Entry ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1SettlingInTracking(
        id: string,
        entryId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/settling-in/{id}/tracking/{entryId}',
            path: {
                'id': id,
                'entryId': entryId,
            },
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Update a tracking entry
     * @param id Plan ID
     * @param entryId Entry ID
     * @param request Tracking entry data
     * @returns settlingin_TrackingEntryResponse OK
     * @throws ApiError
     */
    public static putApiV1SettlingInTracking(
        id: string,
        entryId: string,
        request: settlingin_UpdateTrackingEntryRequest,
    ): CancelablePromise<settlingin_TrackingEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/settling-in/{id}/tracking/{entryId}',
            path: {
                'id': id,
                'entryId': entryId,
            },
            body: request,
            errors: {
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Bulk-create tracking entries for a settling-in plan
     * @param id Plan ID
     * @param request Tracking entries data
     * @returns settlingin_TrackingEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1SettlingInTrackingBulk(
        id: string,
        request: settlingin_BulkCreateTrackingEntriesRequest,
    ): CancelablePromise<Array<settlingin_TrackingEntryResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/{id}/tracking/bulk',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List settling-in plans affected by a billing-config change
     * @param billingMode New billing mode
     * @param billingAmount New billing amount (Rappen); omit for INCLUDED/FREE
     * @param subsidyBillingChoice New subsidy billing choice
     * @returns settlingin_AffectedPlanResponse OK
     * @throws ApiError
     */
    public static getApiV1SettlingInAffectedByBilling(
        billingMode: string,
        billingAmount?: number,
        subsidyBillingChoice?: string,
    ): CancelablePromise<Array<settlingin_AffectedPlanResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settling-in/affected-by-billing',
            query: {
                'billing_mode': billingMode,
                'billing_amount': billingAmount,
                'subsidy_billing_choice': subsidyBillingChoice,
            },
        });
    }
    /**
     * Apply a billing-config change to chosen settling-in plans
     * @param request New billing config + plan ids
     * @returns settlingin_ApplyBillingResponse OK
     * @throws ApiError
     */
    public static postApiV1SettlingInApplyBilling(
        request: settlingin_ApplyBillingRequest,
    ): CancelablePromise<settlingin_ApplyBillingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/settling-in/apply-billing',
            body: request,
        });
    }
}
